import React from 'react';
import './App.css'; // We will create this for App-specific styles
import Header from './components/Header';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import HomePage from './pages/HomePage'; // Import HomePage
import TermsPage from './pages/TermsPage'; // Import TermsPage
import PrivacyPage from './pages/PrivacyPage'; // Import PrivacyPage
import AboutPage from './pages/AboutPage'; // Import AboutPage
import SupportPage from './pages/SupportPage'; // Import SupportPage
import AffiliatePage from './pages/AffiliatePage'; // Import AffiliatePage
import IcmCalculatorPage from './pages/IcmCalculatorPage'; // Import IcmCalculatorPage
import OddsCalculatorPage from './pages/OddsCalculatorPage'; // Import OddsCalculatorPage
import BankrollRiskPage from './pages/BankrollRiskPage'; // Import BankrollRiskPage
import MttVarianceCalculatorPage from './pages/MttVarianceCalculatorPage'; // Import MttVarianceCalculatorPage
import NotFoundPage from './pages/NotFoundPage'; // Import NotFoundPage

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <Header />
          <CookieConsent />
          <Routes>
            <Route path="/" element={<HomePage />} /> {/* Use HomePage component */}
            <Route path="/terms" element={<TermsPage />} /> {/* Add TermsPage route */}
            <Route path="/privacy" element={<PrivacyPage />} /> {/* Add PrivacyPage route */}
            <Route path="/about" element={<AboutPage />} /> {/* Add AboutPage route */}
            <Route path="/marketing" element={<AboutPage />} /> {/* Add /marketing route for AboutPage */}
            <Route path="/support" element={<SupportPage />} /> {/* Add SupportPage route */}
            <Route path="/affiliate" element={<AffiliatePage />} /> {/* Add AffiliatePage route */}
            <Route path="/icm_calculator" element={<IcmCalculatorPage />} /> {/* Add IcmCalculatorPage route */}
            <Route path="/odds_calculator" element={<OddsCalculatorPage />} /> {/* Add OddsCalculatorPage route */}
            <Route path="/bankroll_risk" element={<BankrollRiskPage />} /> {/* Add BankrollRiskPage route */}
            <Route path="/mtt_variance_calculator" element={<MttVarianceCalculatorPage />} /> {/* Add MttVarianceCalculatorPage route */}
<Route path="*" element={<NotFoundPage />} /> {/* 404 route - must be last */}
          </Routes>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App; 